<section>
    <div class="annex-container">
        <h1 class="header-3">Annex V to the Aptoide Connect Certified Developer Distribution Agreement</h1>

        <h4 class="center no-margin-top bottom-margin">Data Sharing Agreement</h4>

        <p class="s">
            This agreement is executed on the same date as the Aptoide Connect Certified Distribution Agreement, by and between Aptoide, S.A., a Portuguese company, with the identification number ID
            509987184 and principal place of business at Rua Soeiro Pereira Gomes, Lote 1, 3D, 1649-031 Lisboa, and its registered office at Rua Fernanda Seno n. 6, 7005-484, Évora, Portugal,
            hereinafter referred to as “Aptoide” and the entity identified as “Certified Developer” in the Aptoide Connect Certified Developer Agreement.
        </p>

        <p class="s">Together referred by “Parties” and individually “Party”. </p>

        <h4>WHEREAS:</h4>

        <p class="s">
            <span class="bold">1.</span>
            The Parties entered into a Aptoide Connect Certified Developer Agreement (the “Contract”) that may require the sharing of Personal Data between the Parties. 
        </p>

        <p class="s">
            <span class="bold">2.</span>
            This Personal Data Processing Agreement (Agreement) sets out the additional terms, requirements and conditions on which the Parties agree to share Personal Data under the Contract. 
        </p>

        <h4>AGREED TERMS</h4>

        <h4>1. DEFINITIONS AND INTERPRETATION</h4>

        <p class="s">The following definitions and rules of interpretation apply in this Agreement. </p>
        <p class="s">
            <span class="bold">1.1</span>
            Definitions
        </p>
        <ol>
            <li class="s thin">
                Business Purposes: the sharing of Personal Data between the Parties under the execution of the Contract in order to allow Aptoide to manage and process payments of in-app purchases and
                to pay to the Certified Developer the applicable revenue share. Certified Developer may also need to use the Personal Data for its own internal business purposes.
            </li>
            <li class="s thin">
                Data Protection Legislation: all applicable privacy and data protection laws including the General Data Protection Regulation ((EU) 2016/679) and any applicable national implementing
                laws, regulations and secondary legislation in Portugal relating to the processing of Personal Data and the privacy of electronic communications, as amended, replaced or updated from
                time to time, including the Privacy and Electronic Communications Directive (2002/58/EC) and the Privacy and Electronic Communications (EC Directive) Regulations 2003 (SI 2003/2426).
            </li>
            <li class="s thin">Data Subject: an individual who is the subject of Personal Data.</li>
            <li class="s thin">
                Personal Data: means any information relating to an identified or identifiable natural person that is processed by the Processor as a result of, or in connection with, the provision of
                the services under the Contract; an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name,
                identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of
                that natural person.
            </li>
            <li class="s thin">
                Permitted Recipients: The parties to this agreement, their Affiliates, the employees of each party, any third parties engaged to perform obligations in connection with this agreement.
            </li>
            <li class="s thin">
                Personal Data Breach: a breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, Personal Data transmitted,
                stored or otherwise processed.
            </li>
            <li class="s thin">
                Processing, processes and process: either any activity that involves the use of Personal Data or as the Data Protection Legislation may otherwise define processing, processes or
                process. It includes any operation or set of operations which is performed on personal data or on sets of personal data, whether or not by automated means, such as collection,
                recording, organisation, structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available,
                alignment or combination, restriction, erasure or destruction. Processing also includes transferring Personal Data to third parties.
            </li>
            <li class="s thin">Shared Personal Data: the personal data to be shared between the parties under the Contract.</li>
            <li class="s thin">
                Standard Contractual Clauses (SCC): Module One (Controller to Controller) of the standard contractual clauses for the transfer of Personal Data to third countries as approved by the
                European Commission in Commission Implementing Decision (EU) 2021/914 of 4 June 2021.
            </li>
        </ol>
        <p class="s">
            <span class="bold">1.2</span>
            This Agreement is subject to the terms of the Contract and is incorporated into the Contract. Interpretations and defined terms set forth in the Contract apply to the interpretation of
            this Agreement.
        </p>
        <p class="s">
            <span class="bold">1.3</span>
            A reference to writing or written includes e-mail.
        </p>
        <p class="s">
            <span class="bold">1.4</span>
            In the case of conflict or ambiguity between:
        </p>
        <ol class="lower-latin">
            <li class="s thin">any provision contained in the body of this Agreement and any provision contained in the Annexes, the provision in the body of this Agreement will prevail;</li>
            <li class="s thin">
                the terms of any accompanying invoice or other documents annexed to this Agreement and any provision contained in the Annexes, the provision contained in the Annexes will prevail;
            </li>
            <li class="s thin">
                any of the provisions of this Agreement and the provisions of the Contract, the provisions of this Agreement will prevail, in what relates to data protection matters; and
            </li>
            <li class="s thin">any of the provisions of this Agreement and any executed SCC, the provisions of the executed SCC will prevail.</li>
        </ol>

        <h4>2. PERSONAL DATA TYPES AND PROCESSING PURPOSES</h4>

        <p class="s">
            <span class="bold">2.1</span>
            The Parties acknowledge that for the purpose of the Data Protection Legislation, each of the Parties will act as a separate and independent controller in relation to the Personal Data
            which they process.
        </p>

        <p class="s">
            <span class="bold">2.2</span>
            Each of the Parties retain control of the Shared Personal Data and remains responsible for its compliance obligations under the applicable Data Protection Legislation, including providing
            any required notices and obtaining any required consents.
        </p>

        <p class="s">
            <span class="bold">2.3</span>
            The Parties undertake to process the Shared Personal Data only for: (1) the Business Purposes and; (2) to comply legal, regulatory and compliance obligations, including without limitation
            as may be required in the course of litigation. The Parties shall be allowed to share the Shared Personal Data with the Permitted Recipients, subcontractors and service providers and store
            such Personal Data in any location.
        </p>

        <p class="s">
            <span class="bold">2.4</span>
            The Shared Personal Data and the Data Subjects which the Parties may process to fulfil the Business Purposes of the Contract are the following:
        </p>

        <ol class="lower-latin">
            <li class="s thin">
                Personal Data Categories: IP address, date and time of the transaction; amount of the transaction; country in which the transaction was executed (based on the IP address).
            </li>
            <li class="s thin">Data Subjects: users who make in-app purchases in the Apps integrated with Aptoide’s IAB.</li>
        </ol>

        <h4>3. PARTIES OBLIGATIONS</h4>

        <p class="s">
            <span class="bold">3.1</span>
            In respect to the Shared Personal Data, each Party shall:
        </p>

        <ol class="lower-latin">
            <li class="s thin">
                ensure that it has all necessary notices and consents in place to enable lawful transfer of the Shared Personal Data to the Permitted Recipients for the Business Purposes;
            </li>
            <li class="s thin">give full information to any data subject whose personal data may be processed under this agreement of the nature such processing;</li>
            <li class="s thin">process the Shared Personal Data only for the purposes determined in Clause 2.3. above;</li>
            <li class="s thin">not disclose or allow access to the Shared Personal Data to anyone other than the Permitted Recipients;</li>
            <li class="s thin">
                ensure that all Permitted Recipients are subject to written contractual obligations concerning the Shared Personal Data (including obligations of confidentiality) which are no less
                onerous than those imposed by this Agreement;
            </li>
            <li class="s thin">
                ensure that it has in place appropriate technical and organisational measures, to protect against unauthorised or unlawful processing of personal data and against accidental loss or
                destruction of, or damage to, personal data;
            </li>
            <li class="s thin">not to transfer any Shared Personal Data outside the EEA unless the transferor:</li>
            <ol>
                <li class="s thin">complies with the provisions of Articles 26 of the GDPR (in the event the third party is a joint controller); and</li>
                <li class="s thin">
                    ensures that (i) the transfer is to a country approved by the European Commission as providing adequate protection pursuant to Article 45 GDPR; (ii) there are appropriate
                    safeguards in place pursuant to Article 46 GDPR; or (iii) one of the derogations for specific situations in Article 49 GDPR applies to the transfer.
                </li>
            </ol>
        </ol>

        <p class="s">
            Without prejudice of the above, to the extent that this Agreement involves a transfer of personal data to a country outside the EU/EEA/UK which has not been recognised by the European
            Commission as offering adequate data protection, and to the further extent that Certified Developer is receiving personal data from Aptoide as a data importer: (a) the Parties hereby
            incorporate Module One (Controller to Controller) of the standard contractual clauses for the transfer of Personal Data to third countries as approved by the European Commission in
            Commission Implementing Decision (EU) 2021/914 of 4 June 2021, (“<span class="bold">SCCs</span>”) into this Agreement as the applicable data transfer mechanism, including the selections
            and information contained in Appendix A of this Agreement; (b) Certified Developer specifically acknowledges its warranty under Clause 14(c) of the SCCs in respect of making the best
            efforts to provide Aptoide with information relevant to the transfer risk assessment and to cooperate with Aptoide in ensuring compliance with the SCCs; and (c) if further regulatory
            guidance becomes available or industry standard practices develop about international data transfers, the Parties shall timely execute an amendment.
        </p>

        <h4>4. MUTUAL ASSISTANCE</h4>

        <p class="s">
            <span class="bold">4.1</span>
            Each party shall assist the other in complying with all applicable requirements of the Data Protection Legislation. In particular, each party shall:
        </p>

        <ol class="lower-latin">
            <li class="s thin">promptly inform the other party about the receipt of any data subject access request in respect to the Shared Personal Data;</li>
            <li class="s thin">provide the other party with reasonable assistance in complying with any data subject access request;</li>
            <li class="s thin">
                assist the other party, at the cost of the other party, in responding to any request from a data subject and in ensuring compliance with its obligations under the Data Protection
                Legislation with respect to security, breach notifications, impact assessments and consultations with supervisory authorities or regulators;
            </li>
            <li class="s thin">notify the other party without undue delay on becoming aware of any breach of the Data Protection Legislation.</li>
            <li class="s thin">
                at the written direction of the Data Discloser, delete or return Shared Personal Data and copies thereof to the Data Discloser on termination of this Agreement unless required by law
                to store the personal data; and
            </li>
            <li class="s thin">
                provide the other Party with contact details of at least one employee as point of contact and responsible manager for all issues arising out of the Data Protection Legislation.
            </li>
        </ol>

        <h4>5. SECURITY</h4>

        <p class="s">
            <span class="bold">5.1</span>
            The Parties undertake to implement appropriate technical and organisational measures against unauthorised or unlawful processing, access, disclosure, copying, modification, storage,
            reproduction, display or distribution of the Shared Personal Data, and against accidental or unlawful loss, destruction, alteration, disclosure or damage of Personal Data.
        </p>

        <p class="s">
            <span class="bold">5.2</span>
            The Parties undertake to implement such measures to ensure a level of security appropriate to the risk involved, including as appropriate:
        </p>

        <ol class="lower-latin">
            <li class="s thin">the pseudonymisation and encryption of personal data;</li>
            <li class="s thin">the ability to ensure the ongoing confidentiality, integrity, availability and resilience of processing systems and services;</li>
            <li class="s thin">the ability to restore the availability and access to personal data in a timely manner in the event of a physical or technical incident; and</li>
            <li class="s thin">a process for regularly testing, assessing and evaluating the effectiveness of security measures.</li>
        </ol>

        <h4>6. TERM AND TERMINATION</h4>

        <p class="s">
            <span class="bold">6.1</span>
            This Agreement will remain in full force and effect so long as:
        </p>
        <ol class="lower-latin">
            <li class="s thin">the Contract remains in effect, or</li>
            <li class="s thin">Any of the Parties retains any Shared Personal Data related to the Contract in its possession or control.</li>
        </ol>
        <p class="s">
            <span class="bold">6.2</span>
            Any provision of this Agreement that expressly or by implication should come into or continue in force on or after termination of the Contract in order to protect Shared Personal Data will
            remain in full force and effect.
        </p>

        <h4>7. INDEMNIFICATION</h4>

        <p class="s">
            <span class="bold">7.1</span>
            Each Party shall indemnify the other against all liabilities, costs, expenses, damages and losses (including but not limited to any direct, indirect or consequential losses, loss of
            profit, loss of reputation and all interest, penalties and legal costs (calculated on a full indemnity basis) and all other reasonable professional costs and expenses) suffered or incurred
            by the indemnified party arising out of or in connection with the breach of the Data Protection Legislation by the indemnifying party, its employees or agents, provided that the
            indemnified party gives to the indemnifier prompt notice of such claim, full information about the circumstances giving rise to it, reasonable assistance in dealing with the claim and sole
            authority to manage, defend and/or settle it.
        </p>

        <h4>8. NOTICES</h4>

        <p class="s">
            <span class="bold">8.1</span>
            Any notice or other communication given to a party under or in connection with this Agreement must be in writing and delivered to the addresses and contacts of the Parties referred to in
            the Contract.
        </p>

        <br />
        <br />
        <br />

        <div class="pagebreak"></div>

        <h4 class="center" style="margin-bottom: 32px">Appendix A <br />(to the Data Sharing Agreement)</h4>

        <p class="s italic">
            The Parties agree that with respect to the purpose of transfer identified below, the following options in the EU SCCs are selected and information inserted when the EU SCCs are
            incorporated into this Agreement:
        </p>

        <ol class="inside">
            <li class="s italic"><span class="bold">Clause 7</span>: Optional docking clause is included;</li>
            <li class="s italic"><span class="bold">Clause 11</span>: The optional clause allowing data subjects to lodge a complaint with an independent dispute resolution body is removed;</li>
            <li class="s italic"><span class="bold">Clause 13</span>: The option for the data exporter established in an EU member state is selected;</li>
            <li class="s italic">
                <span class="bold">Clause 17</span>: The EU Member State where the governing law is stipulated in the Country shall apply, unless this is a not EU Member State, in which case it shall
                be Portugal, as is where Aptoide is established; and
            </li>
            <li class="s italic">
                <span class="bold">Clause 18</span>: The EU Member State where any dispute arising from these Clauses shall be resolved is the courts of the jurisdiction stipulated in the Agreement,
                unless this is not an EU Member State in which case it shall be Portugal.
            </li>
            <li class="s italic">
                <span class="bold">Annex I.A: LIST OF PARTIES</span>
            </li>
            <ol class="inside circle">
                <li class="s italic">
                    <span class="bold">Data exporter:</span>
                </li>
                <ol class="inside square">
                    <li class="s italic"><span class="bold">Name</span>: Aptoide, S.A.</li>
                    <li class="s italic"><span class="bold">Address</span>: Rua Soeiro Pereira Gomes, Lote 1, 3D, 1649-031 Lisboa, Portugal.</li>
                    <li class="s italic"><span class="bold">Contact person’s name and e-mail</span>: Data Privacy Manager, personal-data&#64;aptoide.com</li>
                    <li class="s italic"><span class="bold">Activities relevant to the data transferred under these Clauses</span>: All data processing activities agreed under the Agreement.</li>
                    <li class="s italic"><span class="bold">Signature and date</span>: Signed and dated for and on behalf of the data exporter by execution of this Agreement.</li>
                    <li class="s italic"><span class="bold">Role</span>: Data controller</li>
                </ol>
            </ol>
            <ol class="inside circle">
                <li class="s italic">
                    <span class="bold">Data importer:</span>
                </li>
                <ol class="inside square">
                    <li class="s italic" [class.bold]="(name | async) === defaultValueForInput"><span class="bold">Name</span>: {{ name | async }}</li>
                    <li class="s italic" [class.bold]="(address | async) === defaultValueForInput"><span class="bold">Address</span>: {{ address | async }}</li>
                    <li class="s italic" [class.bold]="(nameAndEmail | async) === defaultValueForInput"><span class="bold">Contact person’s name and e-mail</span>: {{ nameAndEmail | async }}</li>
                    <li class="s italic"><span class="bold">Activities relevant to the data transferred under these Clauses</span>: All data processing activities agreed under the Agreement.</li>
                    <li class="s italic"><span class="bold">Signature and date</span>: Signed and dated for and on behalf of the data importer by execution of this Agreement.</li>
                    <li class="s italic"><span class="bold">Role</span>: Data controller</li>
                </ol>
            </ol>
            <li class="s italic">
                <span class="bold">Annex I.B: DESCRIPTION OF TRANSFER</span>
                <ol class="inside circle">
                    <li class="s italic">
                        <span class="bold">Data subjects</span>: The personal data transferred concern the following categories of data subjects: end users of the Certified Developers Apps
                    </li>
                    <li class="s italic">
                        <span class="bold">Categories of personal data</span>: The personal data transferred concerns the following categories of data: data strictly necessary to provide the
                        integration functionality contemplated under this Agreement
                    </li>
                    <li class="s italic"><span class="bold">Sensitive data transferred</span>: The sensitive personal data transferred concern the following categories of data: none</li>
                    <li class="s italic"><span class="bold">Frequency of transfer</span>: continuous throughout the Term</li>
                    <li class="s italic">
                        <span class="bold">Nature and purpose of the processing</span>: The data processing will be as described under the Agreement and the transfer is made for the following
                        purposes: strictly to enable the integration functionality contemplated under this Agreement
                    </li>
                    <li class="s italic">
                        <span class="bold">Period for which personal data will be retained or criteria to determine that period</span>: Personal Data will be retained as provided for in each of the
                        Parties Privacy Policies
                    </li>
                </ol>
            </li>
            <li class="s italic">
                <span class="bold">Annex I.C: SUPERVISORY AUTHORITY</span>
                <ol class="inside circle">
                    <li class="s italic">
                        <span class="bold">Identify the competent supervisory authority/ies in accordance with Clause 13</span>: Portuguese Authority for Privacy Protection (CNPD)
                    </li>
                </ol>
            </li>
            <li class="s italic">
                <span class="bold">Annex II: TECHNICAL AND ORGANISATIONAL MEASURES INCLUDING TECHNICAL AND ORGANISATIONAL MEASURES TO ENSURE THE SECURITY OF THE DATA</span>
                <ol class="inside circle">
                    <li class="s italic" [class.bold]="(techAndOrgMeasures | async) === defaultValueForInput">{{ techAndOrgMeasures | async }}</li>
                </ol>
            </li>
        </ol>

        <br />
        <br />

        <p class="s">
            <span class="bold">Information for the Transfer Risk Assessment:</span>
        </p>

        <br />

        <p class="s">
            The information below is provided by Certified Developer at the time that the Agreement is executed and any further or updated information may be provided by Certified Developer in
            accordance with this Data Processing Appendix.
        </p>

        <table>
            <tr>
                <th></th>
                <th class="s bold">Transfer Risk Assessment information required by 14(b) of the EU Standard Contractual Clauses</th>
                <th class="s bold">Company Answers</th>
            </tr>
            <tr>
                <td><p class="s">1</p></td>
                <td><p class="s">Location of Company (country of Company entity incorporation and any other material Company data processing locations)</p></td>
                <td>
                    <p class="s" [class.bold]="(companyCountry | async) === defaultValueForInput">{{ companyCountry | async }}</p>
                </td>
            </tr>
            <tr>
                <td><p class="s">2</p></td>
                <td><p class="s">Company’s primary storage location of the data transferred</p></td>
                <td>
                    <p class="small darkBlu" [class.bold]="(companyStorageLocation | async) === defaultValueForInput">{{ companyStorageLocation | async }}</p>
                </td>
            </tr>
            <tr>
                <td><p class="s">3</p></td>
                <td><p class="s">Company’s intention for onward transfer (including the estimated number of further recipients of the data or length of processing chain)</p></td>
                <td>
                    <p class="s" [class.bold]="(companyIntention | async) === defaultValueForInput">{{ companyIntention | async }}</p>
                </td>
            </tr>
            <tr>
                <td><p class="s">4</p></td>
                <td><p class="s">Transmission channel used (i.e. a description of the physical/technological method used to transfer the personal data to Company)</p></td>
                <td>
                    <p class="s" [class.bold]="(transmitionChannel | async) === defaultValueForInput">{{ transmitionChannel | async }}</p>
                </td>
            </tr>
            <tr>
                <td><p class="s">5</p></td>
                <td>
                    <p class="s">
                        a) Is Company subject to any local laws that can require Company to disclose personal data to public authorities or authorise access by public authorities, e.g. FISA 702 in the
                        US? Please state the relevant law.
                    </p>
                    <br />
                    <p class="s">
                        b) Subject to any legal prohibitions on disclosing this information, has Company received any requests from any public authority to disclose personal data under such local laws
                        referenced in a), in the past five years?
                    </p>
                </td>
                <td>
                    <p class="s" [class.bold]="(localLaws | async) === defaultValueForInput">a) {{ localLaws | async }}</p>
                    <br />
                    <p class="s" [class.bold]="(publicAuthorityRequests | async) === defaultValueForInput">b) {{ publicAuthorityRequests | async }}</p>
                </td>
            </tr>
            <tr>
                <td><p class="s">5</p></td>
                <td>
                    <p class="s">
                        Details provided by Company of any relevant contractual, technical or organisational measures Company has implemented to safeguard personal data from interception or
                        disproportionate access by public authorities, during transmission or processing. (This is in addition to Annex II of the EU SCCs).
                    </p>
                </td>
                <td>
                    <p class="s" [class.bold]="(otherMeasures | async) === defaultValueForInput">{{ otherMeasures | async }}</p>
                    <ng-container *ngIf="(otherMeasures | async) === defaultValueForInput">
                        <br />
                        <p class="s italic">Examples:</p>
                        <br />
                        <p class="s italic"><u>Technical</u>: Measures for ensuring:</p>
                        <ol class="inside">
                            <li class="s italic">ongoing confidentiality, integrity, availability and resilience of processing systems and services</li>
                            <li class="s italic">the ability to restore personal data in a timely manner in the event of an incident</li>
                            <li class="s italic">user identification and authorisation</li>
                            <li class="s italic">the protection of data during transmission</li>
                            <li class="s italic">the protection of data during storage</li>
                            <li class="s italic">physical security of locations at which personal data are processed</li>
                            <li class="s italic">events logging</li>
                            <li class="s italic">system configuration, including default configuration</li>
                            <li class="s italic">internal IT</li>
                        </ol>
                        <p class="s italic"><u>Organisational</u>: Measures/processes for:</p>
                        <ol class="inside">
                            <li class="s italic">
                                regularly testing, assessing and evaluating the effectiveness of technical and organisational measures in order to ensure the security of the processing
                            </li>
                            <li class="s italic">IT security governance and management</li>
                            <li class="s italic">ensuring data minimisation</li>
                            <li class="s italic">ensuring data quality</li>
                            <li class="s italic">ensuring limited data retention</li>
                            <li class="s italic">ensuring accountability</li>
                            <li class="s italic">allowing data portability and erasure</li>
                        </ol>
                    </ng-container>
                </td>
            </tr>
        </table>
    </div>
</section>
